module.exports = __webpack_public_path__ + "img/beer_id-117.d90b14a0.png";